












































import { Component, Prop, Mixins } from "vue-property-decorator";

import Checkbox from "@/components/BaseCheckbox/BaseCheckbox.vue";
import BasePopup from "@/components/BasePopup/BasePopup.vue";
import BaseButton from "@/components/BaseButton/BaseButton.vue";
import DataTable from "@/components/DataTable/DataTable.vue";

import EventBus from "@/utils/helpers/EventBus";

import SubjectsTable from "@/mixins/SubjectsTable.mixin";
import { ITeacher } from "@/models/interfaces/teachers";
import { Action } from "vuex-class";
import { AxiosError, AxiosResponse } from "axios";
import { eventCodeByName, EventsNames } from "@/analytics";
import amplitude from "amplitude-js";

@Component({
  components: {
    Checkbox,
    BasePopup,
    BaseButton,
    DataTable
  }
})
export default class TeachersTable extends Mixins<SubjectsTable<ITeacher>>(
  SubjectsTable
) {
  @Prop({ default: false, type: Boolean })
  private loading!: boolean;

  @Action("teachers/deleteTeachers")
  private deleteTeachers!: (
    teachersIds: string[]
  ) => Promise<AxiosResponse | AxiosError>;

  private isDeletionPending = false;

  private get tableColumns() {
    return [
      {
        value: "firstname",
        label: this.$t("tables.reports.firstName")
      },
      {
        value: "lastname",
        label: this.$t("tables.reports.lastName")
      },
      {
        value: "username",
        label: this.$t("tables.reports.username")
      },
      {
        value: "classes",
        label: this.$t("tables.classes.group")
      },
      {
        value: "admin",
        label: this.$t("components.admin")
      }
    ];
  }

  private get computedData() {
    return this.data?.map(row => {
      const classes = row.schools.map(item => item.classes).flat();
      const classesTotal = classes.length;

      const classesValue =
        classesTotal > 1 ? `${classesTotal} groups` : classes[0]?.className;

      return {
        ...row,
        schools: row.schools.length,
        classes: classesValue,
        admin: row.tdAdmin ? "Y" : "N"
      };
    });
  }

  private onDelete() {
    amplitude
      .getInstance()
      .logEvent(
        `${eventCodeByName(EventsNames.UserClicksDeleteTeacher)} ${
          EventsNames.UserClicksDeleteTeacher
        }`
      );

    if (!this.selectedDataItemsIds.length) {
      this.popupMessage = this.$t("components.errors.selectTeachers") as string;
    } else {
      const teachersNames = this.selectedDataItemsIds
        .map(id => {
          const { firstname, lastname } = this.data.find(
            teacher => teacher.userId === id
          )!;

          return `${firstname} ${lastname}`;
        })
        .join(", ");

      this.popupMessage =
        (this.$t(`components.errors.deleteTeachers`) as string) +
        ` ${teachersNames} `;
      this.action = "delete";
    }

    this.showPopup = true;
  }

  private onAdd() {
    amplitude
      .getInstance()
      .logEvent(
        `${eventCodeByName(EventsNames.UserClicksAddTeacher)} ${
          EventsNames.UserClicksAddTeacher
        }`
      );
    this.$router.push("/teachers/add");
  }

  private onEdit() {
    amplitude
      .getInstance()
      .logEvent(
        `${eventCodeByName(EventsNames.UserClicksEditTeacher)} ${
          EventsNames.UserClicksEditTeacher
        }`
      );

    if (!this.selectedDataItemsIds.length) {
      this.popupMessage = this.$t("components.errors.selectTeachers") as string;
      this.showPopup = true;
    } else if (this.selectedDataItemsIds.length > 1) {
      this.popupMessage = this.$t(
        "components.errors.editOneTeacherAtOnce"
      ) as string;
      this.showPopup = true;
    } else {
      this.$router.push(`/teachers/${this.selectedDataItemsIds[0]}/edit`);
    }
  }

  public onPopupSubmit() {
    this.showPopup = false;

    switch (this.action) {
      case "delete":
        amplitude
          .getInstance()
          .logEvent(
            `${eventCodeByName(
              EventsNames.UserClicksOkOnPopupAfterTeacherDelete
            )} ${EventsNames.UserClicksOkOnPopupAfterTeacherDelete}`
          );
        this.deleteTeachersFromList();
        break;

      default:
        break;
    }
  }

  private async deleteTeachersFromList() {
    this.isDeletionPending = true;

    this.deleteTeachers(this.selectedDataItemsIds)
      .then(r => {
        const error = r instanceof Error;

        if (error) {
          const { response } = r as AxiosError;

          if (!response || response.status !== 403) {
            this.action = "";
            this.popupMessage = this.$t(
              "components.errors.failedToDeleteTeachers"
            ) as string;
            this.showPopup = true;
          }
        } else {
          this.selectedDataItemsIds = [];
        }
      })
      .finally(() => (this.isDeletionPending = false));
  }

  private mounted() {
    EventBus.$on("table-toolbar-delete", this.onDelete);
    EventBus.$on("table-toolbar-add", this.onAdd);
    EventBus.$on("table-toolbar-edit", this.onEdit);

    this.selectedDataItemsIds = this.selectedItems;
  }

  private beforeDestroy() {
    EventBus.$off("table-toolbar-delete", this.onDelete);
    EventBus.$off("table-toolbar-add", this.onAdd);
    EventBus.$off("table-toolbar-edit", this.onEdit);
  }
}
